import { Link, useNavigate } from "react-router-dom";
import React, { startTransition, useCallback, useEffect, useState } from "react";
import Slider from "react-slick";
import { API_URL } from "../../_services/apiUrl";
import { get } from "../../_services/apiService";
import { toast } from "react-toastify";
import { addToCart } from "../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { useWishlist } from "../../context/wishlistContext";
import { ToastContainer } from "react-toastify";

const imageUrl = process.env.REACT_APP_IMAGE_BASE_URL

const TopProducts = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    const loginId = localStorage.getItem('loginId');
    const [productDetail, setProductDetail] = useState([]);
    const [productCategoryData, setProductCategoryData] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const { addToWishlist, removeFromWishlist } = useWishlist();
    const [subCategoryData, setSubCategoryData] = useState([]);

    const cartData = useSelector((state) => state.cartReducer.cart) || [];

    const [formData, setFormData] = useState({
        skuId: 0,
        cartItemId: 0,
        productId: 0,
        loginId: loginId ? Number(loginId) : 0,
        buyStatus: 1,
        quantity: 1,
        isActive: true,
        createdBy: 0,
        unitPrice: 0,
        totalAmount: 0
    });

    const [wishListForm, setWishListForm] = useState({
        wishProductId: 0,
        loginId: loginId ? Number(loginId) : 0,
        productId: 0,
        isActive: true,
        createdBy: 0
    });

    const GetProductCategoryDetail = async () => {
        setLoading(true);
        try {
            const response = await get(API_URL?.GetProductCategory);
            if (response.isSuccess === 200) {
                const filteredData = response?.data?.filter(product => product.isDisplay);
                setProductCategoryData(filteredData);
            } else {
                setError('Category data not Avaiable.');
            }
        } catch (error) {
            setError('Category data not Avaiable.');
        } finally {
            setLoading(false);
        }
    };

    const GetProductSubCategoryByCategoryId = async () => {
        try {
            const response = await get(`${API_URL?.GetProductSubCategory}`);
            if (response.isSuccess === 200) {
                const filteredData = response?.data?.filter(product => product.isDisplay);
                setSubCategoryData(filteredData);
            }
        } catch (error) {
            setSubCategoryData([]);
        }
    };

    const GetProductDetail = useCallback(async () => {
        try {
            const response = await get(API_URL?.GetProductDetail);
            if (response.isSuccess === 200) {
                const filteredData = response?.data
                    ?.filter(product => product.isDisplay)
                    ?.sort((a, b) => {
                        // Put null or undefined showOrder at the end
                        if (a.showOrder == null) return 1;
                        if (b.showOrder == null) return -1;
                        return a.showOrder - b.showOrder;
                    });
                setProductDetail(filteredData);
            } else {
                setError('Product data not available.');
            }
        } catch (error) {
            setError('Product data not available.');
        } finally {
            setLoading(false);
        }
    }, [loginId]);

    useEffect(() => {
        GetProductDetail();
    }, [GetProductDetail]);

    useEffect(() => {
        GetProductCategoryDetail();
        GetProductSubCategoryByCategoryId();
    }, []);

    const handleImageError = (e) => {
        e.target.src = './images/defaultImage.png';
    };

    const onProductDetail = (item) => {
        localStorage.removeItem('sizeTypeName');
        localStorage.removeItem('colorTypeName');
        localStorage.removeItem('skuId');
        localStorage.removeItem('colorId');
        const existingItemDetails = JSON.parse(localStorage.getItem('itemDetail')) || [];
        const existingCartItemDetails = JSON.parse(localStorage.getItem('cartItemDetail')) || [];

        if (existingItemDetails.length > 0 || existingCartItemDetails.length > 0) {
            localStorage.removeItem('cartItemDetail');
            localStorage.removeItem('itemDetail');
        }
        localStorage.setItem('productId', item?.productId);

        navigate(`/${item?.categoryName.replace(/\s+/g, '_')}/${item?.productSubCategoryName.replace(/\s+/g, '_')}/${item?.productName.replace(/\s+/g, '_')}/${item?.productId}`);
        sessionStorage.setItem('priviousUrl', `/${item?.categoryName.replace(/\s+/g, '_')}/${item?.productSubCategoryName.replace(/\s+/g, '_')}/${item?.productName.replace(/\s+/g, '_')}/${item?.productId}`);
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 2000,
    };

    // // Filter products based on selected category
    useEffect(() => {
        if (productDetail && productDetail.length > 0) {

            if (selectedCategory) {
                const filtered = productDetail.filter(product => {

                    if (typeof product?.rcategoryId === 'string') {
                        return product.rcategoryId.split(',').includes(String(selectedCategory));
                    }

                    return false;
                });

                setFilteredProducts(filtered);
            } else {
                setFilteredProducts(productDetail);
            }
        }
    }, [selectedCategory, productDetail]);

    const handleCategoryClick = (categoryId) => {
        if (selectedCategory === categoryId) {
            setSelectedCategory(null);
        } else {
            setSelectedCategory(categoryId);
        }
    };

    const onAddCart = async (item) => {
        try {
            const cartQuantity = cartData?.find(cartItem => Number(cartItem.productId) === Number(item?.productId));

            const initialQuantity = cartQuantity ? cartQuantity.quantity + 1 : 1;

            const updatedFormData = {
                ...formData,
                productId: item?.productId ? Number(item?.productId) : formData.productId,
                skuId: item?.productSkuDtos ? item?.productSkuDtos[0].skuId : 0,
                quantity: initialQuantity,
                unitPrice: item?.productSkuDtos ? item?.productSkuDtos[0].salePrice : 0,
                totalAmount: item?.productSkuDtos ? item?.productSkuDtos[0].salePrice : 0
            };

            await dispatch(addToCart(updatedFormData));

            setTimeout(() => {
                startTransition(() => {
                    navigate('/cart');
                })
            }, 500);
            setFormData({
                skuId: 0,
                cartItemId: 0,
                productId: 0,
                loginId: loginId ? Number(loginId) : 0,
                buyStatus: 1,
                quantity: 1,
                isActive: true,
                createdBy: 0,
                unitPrice: 0,
                totalAmount: 0
            })
        } catch (error) {
            toast.error("Failed Item Add on Cart");
        }
    };

    const onWishlistToggle = async (item) => {
        if (loginId) {
            const updatedWishListForm = {
                ...wishListForm,
                productId: item?.productId || 0
            };

            setWishListForm(updatedWishListForm);

            if (item.wishStatus) {
                await removeFromWishlist(item);
                GetProductDetail();
                toast.success('Remove to wishlist!');
            } else {
                await addToWishlist(updatedWishListForm);
                GetProductDetail();
                toast.success('Add to wishlist!');
            }
        } else {
            startTransition(() => {
                navigate('/login');
            })
        }
    };

    if (loading) return <div className="loading_content"><img src="./images/loading.gif" alt="Hand-stitched chikankari kurta – Gailee" /></div>;
    if (error) return <div>data not avaiable...</div>;

    return (
        <section>
            <ToastContainer
                position="top-right"
                className="toaster"
                autoClose={1500}
                hideProgressBar={true}
                pauseOnHover={false}
                draggable={false}
            />
            {filteredProducts !== null && (
                <div className="our_top_product_woepper">
                    <div className="container">
                        <div className="our_top_product_inner">
                            <h2>Our Top Products</h2>
                            <div className="drop_dawn_product_wepper">
                                <div className="drop_dawn_flex">
                                    <li className="nav-item dropdown">
                                        <Link className="nav-link dropdown-toggle" to="#" role="button" data-bs-toggle="dropdown"
                                            aria-expanded="false">
                                            Categories
                                            <span className="sub-arrow"><i className="fas fa-chevron-down"></i></span>
                                        </Link>
                                        <ul className="dropdown-menu">
                                            <li key="all cursor-pointer">
                                                <span
                                                    onClick={() => handleCategoryClick(null)}
                                                    className={`cursor-pointer dropdown-item ${selectedCategory === null ? 'selected' : ''}`}
                                                >
                                                    All
                                                </span>
                                            </li>
                                            {productCategoryData && productCategoryData !== null ? (
                                                productCategoryData.map((item, i) => {
                                                    const matchedSubCategories = subCategoryData.filter(
                                                        (sub) => sub.productCategoryId === item.productCategoryId && sub.isDisplay
                                                    );

                                                    if (matchedSubCategories.length === 0) {
                                                        return null;
                                                    }

                                                    return (
                                                        <li key={i} className="cursor-pointer">
                                                            <span
                                                                onClick={() => handleCategoryClick(item.productCategoryId)}
                                                                className={`dropdown-item ${selectedCategory === item.productCategoryId ? 'selected' : ''}`}
                                                            >
                                                                {item.displayName}
                                                            </span>
                                                        </li>
                                                    )
                                                })
                                            ) : (
                                                <li><Link className="dropdown-item" to="#">Data not available</Link></li>
                                            )}

                                        </ul>
                                    </li>
                                </div>
                            </div>
                        </div>

                        <div className="row" data-aos="fade-down">
                            {filteredProducts.slice(0, 8).map((item, index) => (
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6" key={index}>
                                    <div className="img_book">
                                        <div className="product_img_book">
                                            <div id="topproduct" className="owl-carousel owl-theme">
                                                {(() => {
                                                    // STEP 1: Extract image sources from SKU or fallback
                                                    const skuImages = item?.productSkuDtos?.[0]?.productImageDtos;
                                                    const fallbackImages = item?.productImageDtos;

                                                    // Use SKU images if they exist, otherwise fallback to product-level images
                                                    let imagesToRender = [];

                                                    if (skuImages && skuImages.length > 0) {
                                                        imagesToRender = skuImages;
                                                    } else if (fallbackImages && fallbackImages.length > 0) {
                                                        imagesToRender = [...fallbackImages].sort((a, b) => (b.isHeader ? 1 : 0) - (a.isHeader ? 1 : 0));
                                                    } else {
                                                        imagesToRender = [{ imgPath: null }];
                                                    }

                                                    return imagesToRender.length > 1 ? (
                                                        <Slider {...settings}>
                                                            {imagesToRender.map((image, j) => {
                                                                const imgSrc = image?.imgPath
                                                                    ? `${imageUrl}${image.imgPath}`
                                                                    : './images/defaultImage.png';

                                                                return (
                                                                    <div className="item" key={j}>
                                                                        <span>
                                                                            <img
                                                                                src={imgSrc}
                                                                                alt={`Product ${j + 1}`}
                                                                                className="w-100"
                                                                                onError={handleImageError}
                                                                                onClick={() => onProductDetail(item)}
                                                                                style={{ cursor: 'pointer' }}
                                                                            />
                                                                        </span>
                                                                    </div>
                                                                );
                                                            })}
                                                        </Slider>
                                                    ) : (
                                                        <div className="shop_occasion_img_book">
                                                            <div className="overflow-hidden">
                                                                <img
                                                                    src={
                                                                        imagesToRender[0]?.imgPath
                                                                            ? `${imageUrl}${imagesToRender[0].imgPath}`
                                                                            : './images/defaultImage.png'
                                                                    }
                                                                    alt="Product"
                                                                    className="w-100"
                                                                    onError={handleImageError}
                                                                    onClick={() => onProductDetail(item)}
                                                                    style={{ cursor: 'pointer' }}
                                                                />
                                                            </div>
                                                        </div>
                                                    );
                                                })()}


                                                {/* {item?.productImageDtos?.length > 0 ? (
                                                    item.productImageDtos.length > 1 ? (
                                                        <Slider {...settings}>
                                                            {item.productImageDtos.map((image, j) => (
                                                                <div className="item" key={j}>
                                                                    <span>
                                                                        <img
                                                                            src={image?.imgPath ? `${imageUrl}${image?.imgPath}` : './images/defaultImage.png'}
                                                                            alt={`Product Image ${j + 1}`}
                                                                            className="w-100"
                                                                            onError={handleImageError}
                                                                            onClick={() => onProductDetail(item)}
                                                                            style={{ cursor: 'pointer' }}
                                                                        />
                                                                    </span>
                                                                </div>
                                                            ))}
                                                        </Slider>
                                                    ) : (
                                                        <div>
                                                            <span>
                                                                <img
                                                                    src={item.productImageDtos[0]?.imgPath ? `${imageUrl}${item.productImageDtos[0]?.imgPath}` : './images/defaultImage.png'}
                                                                    alt="Product Image"
                                                                    className="w-100"
                                                                    onError={handleImageError}
                                                                    onClick={() => onProductDetail(item)}
                                                                    style={{ cursor: 'pointer' }}
                                                                />
                                                            </span>
                                                        </div>
                                                    )
                                                ) : (
                                                    <div className="shop_occasion_img_book">
                                                        <div className="overflow-hidden">
                                                            <img
                                                                src="./images/defaultImage.png"
                                                                alt="Product Image Unavailable"
                                                                className="w-100"
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                        </div>
                                                    </div>
                                                )} */}
                                            </div>

                                            <div className="left_side_icon_weper">
                                                <ul>
                                                    <li><span onClick={() => onWishlistToggle(item)} className="active curser-pointer">
                                                        <img src="images/dark-heart.svg" alt="Hand-stitched chikankari kurta – Gailee" />
                                                    </span >
                                                    </li>
                                                    <li>
                                                        <span className="product_cart_button curser-pointer" onClick={() => onAddCart(item)}>
                                                            <img src="images/Bag.svg" alt="Hand-stitched chikankari kurta – Gailee" />
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="product_wepper">
                                            <h3 title={item?.displayName} onClick={() => onProductDetail(item)} style={{ cursor: 'pointer', textTransform: 'capitalize' }}>{item?.displayName?.length > 25 ? `${item.displayName.substring(0, 25)}...` : item?.displayName}</h3>
                                            <p
                                                dangerouslySetInnerHTML={{
                                                    __html: item?.shortDesc?.length > 35 ? `${item.shortDesc.substring(0, 35)}...` : item?.shortDesc
                                                }}
                                                title={item?.shortDesc}
                                            />
                                            <div className="product_price ">
                                                <div className="product_price_top_product"><del>Rs.{item?.productSkuDtos !== null ? item?.productSkuDtos[0]?.mrp : item?.mrp}</del> <span>Rs.{item?.productSkuDtos !== null ? item?.productSkuDtos[0]?.salePrice : item?.salePrice}</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            ))
                            }
                        </div>
                        <div className="line_wepper"></div>
                    </div>
                </div >
            )}
        </section >
    )
}

export default TopProducts;